import { Controller } from 'stimulus'

const SIDEBAR_SCROLL_OFFSET = 80

export default class SidebarNav extends Controller {
  static values = { isMobile: Boolean, isLegal: Boolean }

  static targets = [
    'primaryItem',
    'secondaryItem',
    'tertiaryItem',
    'activeItem',
    'primaryGroup',
    'secondaryGroup',
    'tertiaryGroup',
  ]

  connect() {
    // Hide inactive secondary and tertiary items
    if (this.hasPrimaryGroupTarget && this.isLegalValue) {
      this.hideInactiveItems()
      this.highlightParentElement()
    }

    // Scroll the sidebar navigation to the primary or secondary active menuitem
    this.scrollToActiveItem()
  }

  disconnect() {
    if (this.headingsObserver) {
      this.headingsObserver.disconnect()
    }
  }

  hideInactiveItems() {
    const groups = this.tertiaryGroupTargets.concat(this.secondaryGroupTargets)
    groups.forEach((group) => {
      if (!group.querySelector('.is-active') && !group.previousElementSibling.classList.contains('is-active')) {
        group.classList.add('is-hidden')
      }
    })
  }

  highlightParentElement() {
    const secondaryAndTertiaryElements = this.tertiaryItemTargets.concat(this.secondaryItemTargets)
    const activeElement = secondaryAndTertiaryElements
      .filter((element) => element.classList.contains('is-active'))
      .pop()

    activeElement.closest('ul').previousElementSibling.classList.add('is-active')
  }

  get activeItem() {
    return this.activeItemTargets.pop() || null
  }

  scrollToActiveItem() {
    if (this.activeItem) {
      if (this.isMobileValue) {
        this.element.parentElement.scroll({ top: this.activeItem.offsetTop - 40 })
      }
      this.element.scroll({ top: this.activeItem.offsetTop - SIDEBAR_SCROLL_OFFSET })
    }
  }
}
